export interface Page {
  id: number;
  name: string;
  slug: string;
  body: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const pageFromResponse = (responseData: any): Page => ({
  id: responseData.id,
  name: responseData.name,
  slug: responseData.slug,
  body: responseData.body,
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
